/**
 * Instant de la dernière image servie, posé à la construction (`VITE_DEPLOYED_AT`, ISO 8601).
 * Absent en développement : il n'y a pas de version déployée tant qu'aucune image n'a été bâtie.
 */

const CABINET_ZONE = 'Europe/Luxembourg';

export function readDeployedAt(raw: string | undefined): Date | null {
  if (raw === undefined || raw.trim() === '') return null;
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function deployedAt(): Date | null {
  return readDeployedAt(import.meta.env.VITE_DEPLOYED_AT);
}

/** Jour et heure courts de cette image, à l'heure murale du cabinet. */
export function formatDeployedAt(date: Date, language: string): string {
  return new Intl.DateTimeFormat(language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone: CABINET_ZONE,
  }).format(date);
}
